import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../utils/analytics";

export default function MetaPixelRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    // Payment links grant access to a private payment request. Never send them
    // to advertising/analytics providers or initialize tracking on these pages.
    if (location.pathname === "/admin" || location.pathname.startsWith("/payment/")) return;
    trackPageView(location.pathname, location.search);
  }, [location.pathname, location.search]);

  return null;
}
